import { LMS_WEBAPP_CONFIG_IMPL } from "../../infecto-lms-webapp-impl/config";

export const isWissenwirktApp =
	LMS_WEBAPP_CONFIG_IMPL.brandId ==
	"QnJhbmQ6QnJhbmQ6MWVkZDQ2YzYtODkwMC00YTI4LTk1MTEtNTllYzgyNzVhNDg0";
